import axios from 'axios';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const RELATED_ARTICLE_URL = '/smarthelp/related-article';

export function resetRelatedArticle() {
  return { type: types.RESET_RELATED_ARTICLE };
}

function requestRelatedArticle() {
  return {
    type: types.REQUEST_RELATED_ARTICLE,
    payload: undefined,
  };
}

function receiveRelatedArticle(responseData) {
  return {
    type: types.RECEIVE_RELATED_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveRelatedArticleError() {
  return {
    type: types.RECEIVE_RELATED_ARTICLE_ERROR,
    payload: undefined,
  };
}

export function fetchRelatedArticle(topicName) {
  return (dispatch) => {
    dispatch(requestRelatedArticle());
    return axios.get(`${RELATED_ARTICLE_URL}?q=${Page.getSanitizedValue(topicName)}`, {
      cancelToken: source.token,
    })
      .then((response) => {
        if (!response.data || !response.data.length) {
          // Dispatching error actions when API returns 200 with empty response
          dispatch(receiveRelatedArticleError());
        } else {
          dispatch(receiveRelatedArticle(response.data));
        }
      })
      .catch(() => (
        dispatch(receiveRelatedArticleError())
      ));
  };
}

export function cancelRelatedArtilceRequest() {
  source.cancel('Related article request canceled.');
}
